import PricingPage from "./PricingPage";

export default PricingPage;
